class GenderSelection extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('[data-gender-selection]').forEach(genderSelection =>
        genderSelection.addEventListener('click', this.setSelection.bind(this))
      );
    }
    setSelection(event) {
      event.preventDefault();
      const a = event.target.closest('a');
      const href = a.getAttribute('href');
      const gender = a.getAttribute('data-gender-type');
      window.setGender(href, gender);
    }
}
  
customElements.define('gender-selection', GenderSelection);
  